import moment, { Moment } from 'moment'
import lodash from 'lodash'
import { produce } from 'immer'
import { InformationList } from '@/pages/admit/information/data.d'
import * as services from '@/pages/admit/information/service'
import { formatSearch } from './util'
import { cloneDeep } from 'lodash'
import { deepEqual } from '@/utils/utils'

export interface ModelState {
  informationList: InformationList
  informationTotal: number
  informationSearch: {
    cnick?: string // 顾客姓名
    task_name?: string // 仿真训练名称
    date_range: Moment[]
    current_page: number
    page_size: number
    task_execute_record_id: string
  }
  isDefaultSearch: boolean
}

export const initialValues = {
  current_page: 1,
  page_size: 20,
  cnick: undefined,
  task_name: undefined,
  date_range: [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')],
  task_execute_record_id: undefined,
}

export const initialSearch = {
  page: { page_size: 20, page_num: 1 },
  begin_timestamp: moment().startOf('day').unix(),
  end_timestamp: moment().endOf('day').unix(),
}

const TrainModel = {
  namespace: 'informationList',

  state: {
    informationList: [],
    informationTotal: 0,
    informationSearch: lodash.cloneDeep(initialValues),
    taskList: {},
    searchValue: { ...initialSearch, task_type: 0 },
    isDefaultSearch: true,
    detailsList: [],
    topActiveVal: 0,
  },

  subscriptions: {
    setup: ({ dispatch, history }) => {
      return history.listen(({ pathname }) => {
        if (pathname !== '/exam/admit/information') {
          dispatch({
            type: 'informationList/resetSearchValue',
          })
        }
      })
    },
  },

  effects: {
    *fetchInformationList({ payload = {} }, { call, put, select }) {
      const { ...rest } = payload
      const { informationSearch } = yield select((store) => store.informationList)
      const params = formatSearch({
        ...informationSearch,
        ...payload,
      })
      const result = yield call(services.fetchInformationList, params)
      yield put({
        type: 'setState',
        payload: {
          informationSearch: { ...informationSearch, ...rest },
          informationList: result?.data?.data || [],
          informationTotal: result?.data?.page?.total || 0,
        },
      })
    },

    *dialogDetail({ payload }, { call, put }) {
      const result = yield call(services.dialogDetail, payload)
      return result
    },

    *taskList({ payload }, { call, put }) {
      const result = yield call(services.taskList, payload)
      yield put({
        type: 'setState',
        payload: {
          taskList: result.data,
        },
      })
      return result
    },

    *editQuality({ payload }, { call, put }) {
      const result = yield call(services.editQuality, payload)
      return result
    },

    *searchRecord({ payload }, { call, put }) {
      const result = yield call(services.searchRecord, payload)
      const dataList = result?.data?.data?.map((item) => {
        item.foundation = item.ai_evaluates?.filter((i) => i.standard == 1)[0]?.score
        item.attitude = item.ai_evaluates?.filter((i) => i.standard == 2)[0]?.score
        item.settle = item.ai_evaluates?.filter((i) => i.standard == 3)[0]?.score
        item.conscious = item.ai_evaluates?.filter((i) => i.standard == 4)[0]?.score
        item.skill = item.ai_evaluates?.filter((i) => i.standard == 5)[0]?.score
        item.red_line = item.ai_evaluates?.filter((i) => i.standard == 6)[0]?.score
        return item
      })
      yield put({
        type: 'setState',
        payload: {
          detailsList: {
            data: dataList,
            page: result.data.page,
          },
        },
      })
      return result
    },
  },
  reducers: {
    setState: produce((state, action) => ({
      ...state,
      ...action.payload,
    })),
    setSearchValue: produce((state, { payload }) => {
      // 比较除任务类型外其他部分是否更改
      const copySearchValue = cloneDeep({ ...state.searchValue, ...payload })
      copySearchValue.task_type && delete copySearchValue.task_type
      const isAnyChange = deepEqual(copySearchValue, initialSearch)

      state.searchValue = { ...state.searchValue, ...payload }
      if (!isAnyChange) {
        state.isDefaultSearch = false
      }
    }),
    resetSearchValue: produce((state) => {
      state.searchValue = { ...initialSearch, task_type: state.topActiveVal }
      state.isDefaultSearch = true
    }),
  },
}

export default TrainModel
